<template>
  <div class="app-container">
    <div class="filter-container">
      <el-form :inline="true" label-position="top" label-width="100px" class="custom-form">
        <el-form-item label="员工姓名" class="custom-item">
          <el-input v-model="listQuery.empName" placeholder="员工姓名" />
        </el-form-item>
        <el-form-item label="所属站点" class="custom-item">
          <el-select v-model="listQuery.stationId" placeholder="加油站点" class="filter-item">
            <el-option v-if="isAllStation === 1" label="全部" value />
            <el-option
              v-for="(item,index) in stationLists"
              :key="index"
              :label="item.stationName"
              :value="item.stationId"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('table.status')" class="custom-item">
          <el-select
            v-model="listQuery.status"
            :placeholder="$t('table.status')"
            class="filter-item"
          >
            <el-option label="全部" value="-2" />
            <el-option
              v-for="(item,index) in statusType"
              :key="index"
              :label="item"
              :value="index"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('seting.empType')" class="custom-item">
          <el-select
            v-model="listQuery.empType"
            :placeholder="$t('seting.empType')"
            class="filter-item"
          >
            <el-option label="全部" value />
            <el-option v-for="(item,index) in empTypes" :key="index" :label="item" :value="index" />
          </el-select>
        </el-form-item>
      </el-form>
      <p style="text-align:center">
        <el-button
          v-waves
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleFilter"
        >{{ $t('table.search') }}</el-button>
        <el-button
          class="filter-item"
          style="margin-left: 10px;"
          type="primary"
          icon="el-icon-edit"
          @click="handleCreate"
        >{{ $t('table.add') }}</el-button>
      </p>
    </div>

    <el-table
      v-loading="listLoading"
      :key="tableKey"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%"
    >
      <el-table-column :label="$t('seting.stationName')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.stationName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="员工登录名" align="center" min-width="140px">
        <template slot-scope="scope">
          <span>{{ scope.row.loginName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('seting.empName')" align="center" min-width="70px">
        <template slot-scope="scope">
          <span>{{ scope.row.empName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('seting.cardNo')" align="center" min-width="140px">
        <template slot-scope="scope">
          <span>{{ scope.row.cardNo }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('seting.title')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('grade.status')" align="center" min-width="50px">
        <template slot-scope="scope">
          <span>{{ scope.row.status | statusFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('table.actions')"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.empType==1"
            type="primary"
            size="mini"
            @click="handleUpdate(scope.row)"
          >{{ $t('table.edit') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.pi"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.ps"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      v-if="dialogFormVisible"
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible"
      width="800px"
    >
      <el-tabs type="border-card">
        <el-tab-pane>
          <span slot="label">
            <i class="el-icon-date" /> 基本资料
          </span>
          <el-form
            ref="dataForm"
            :rules="rules"
            :model="temp"
            :inline="true"
            label-position="right"
            label-width="120px"
          >
            <!--            <el-form-item v-if="temp.empId" label="员工ID" prop="empId">
              <el-input v-model="temp.empId" :disabled="true"/>
            </el-form-item>-->
            <el-form-item :label="$t('seting.empName')" prop="empName">
              <el-input v-model="temp.empName" />
            </el-form-item>
            <el-form-item :label="$t('seting.title')" prop="title">
              <el-input v-model="temp.title" />
            </el-form-item>
            <el-form-item :label="$t('seting.phoneNum')" prop="phoneNum">
              <el-input v-model="temp.phoneNum" minlength="8" />
            </el-form-item>
            <el-form-item :label="$t('seting.loginPwd')" prop="loginPwd">
              <el-input v-model="temp.loginPwd" />
            </el-form-item>
            <el-form-item v-if="temp.stationId === temp.groupId" label="选择站点" prop="stationId">
              <el-select :disabled="true" placeholder="集团管理员" style="width:190px" />
            </el-form-item>
            <el-form-item v-else label="所属站点" prop="stationId">
              <el-select v-model="temp.stationId" placeholder="选择站点" style="width:190px">
                <el-option
                  v-for="(item) in stationLists"
                  :key="item.stationId"
                  :label="item.stationName"
                  :value="item.stationId"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="temp.empId" :label="$t('table.status')" prop="status">
              <el-select
                v-model="temp.status"
                :placeholder="$t('table.status')"
                value-key="value"
                class="filter-item"
                style="width:190px"
              >
                <el-option
                  v-for="(item,index) in statusArr"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="卡号" prop="cardNo">
              <el-input v-model="temp.cardNo" />
            </el-form-item>
            <!-- <el-form-item label="物理卡号" prop="phyCardNo">
              <el-input v-model="temp.phyCardNo"/>
            </el-form-item>-->
            <el-row :gutter="18">
              <el-col :span="18">
                <el-form-item label="管理站点：">
                  <!--<el-checkbox v-model="checkedAdmin" name="isAdmin" @change="handleCheck">所属站点：</el-checkbox>-->
                  <!--                  <el-checkbox
                    v-model="checkedAllStation"
                    name="isAllStation"
                    @change="handleCheck"
                  >集团下所有站点
                  </el-checkbox>-->
                  <el-radio v-model="allStationCheck" label="0" @change="radioBind">所属站点</el-radio>
                  <el-radio v-model="allStationCheck" label="1" @change="radioBind">集团下所有站点</el-radio>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="员工权限">
          <el-form>
            <!-- <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item prop="permissionJson">
                  <el-checkbox
                    :indeterminate="isIndeterminate"
                    v-model="temp.isAllPer"
                    name="isAllPer"
                    @change="handleCheckAllChange"
                  >全选</el-checkbox>
                  <el-main>
                    <el-checkbox-group v-model="permissions" @change="handleCheckedCitiesChange">
                      <el-checkbox
                        v-for="item in permissionList"
                        :label="item.name"
                        :key="item.id"
                      >{{ item.name }}</el-checkbox>
                    </el-checkbox-group>
                  </el-main>
                </el-form-item>
              </el-col>
            </el-row>-->

            <el-row v-for="item in permissionGroupList" :gutter="24" :key="item.groupId">
              <el-col :span="24">
                <el-form-item prop="permissionJson">
                  <el-checkbox
                    :indeterminate="isIndeterminate"
                    v-model="item.checkStatus"
                    :style="{fontWeight:'bold'}"
                    name="isAllPer"
                    @change="handleCheckAllGroupChange(item)"
                  >{{ item.groupName }}</el-checkbox>
                  <el-main :style="{padding:0}">
                    <el-checkbox-group
                      v-model="permissionsAll"
                      @change="handleCheckedItemChange(item)"
                    >
                      <el-checkbox
                        v-for="item in item.permissions"
                        :label="item.name"
                        :key="item.id"
                      >{{ item.name }}</el-checkbox>
                    </el-checkbox-group>
                  </el-main>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{ $t('table.cancel') }}</el-button>
        <el-button
          v-if="dialogStatus=='create'"
          type="primary"
          @click="createData"
        >{{ $t('table.confirm') }}</el-button>
        <el-button v-else type="primary" @click="updateData">{{ $t('table.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  empList,
  empAdd,
  empUpdate,
  getEmpPermission,
  listSystemPermission,
  listGroupPermission
} from '@/api/setting';
import { stationList } from '@/api/station';
import waves from '@/directive/waves'; // 水波纹指令
import { checkEmpPwd } from '@/api/setting';
import { isNumber } from '@/utils/validate';
import { getEmpInfo } from '@/utils/auth';
const typeOptions = { 1: '平台操作员', 2: '站点操作员' }
const statusMap = { '-1': '注销', '0': '冻结', '1': '正常' }
const statusArr = [
  { label: '注销', value: -1 },
  { label: '冻结', value: 0 },
  { label: '正常', value: 1 }
]
export default {
  name: 'ComplexTable',
  directives: {
    waves
  },
  filters: {
    statusFilter (status) {
      return statusMap[status + '']
    }
  },
  data () {
    const checkPhone = (rule, value, callback) => {
      if (value.length < 8 || !isNumber(value)) {
        callback(new Error('请输入正确电话'))
      } else {
        callback()
      }
    }
    return {
      allStationCheck: '0',
      tableKey: 0,
      stationLists: [],
      list: [],
      total: null,
      listLoading: true,
      checkedAdmin: false,
      checkedAllStation: false,
      temp: {
        empId: 0,
        empName: '',
        title: '',
        phoneNum: '',
        loginPwd: '',
        cardNo: '',
        // phyCardNo:'',
        isAdmin: '',
        isAllStation: '',
        stationId: '',
        stationName: '',
        permissionJson: [],
        isAllPer: '',
        status: 0
      },
      dialogFormVisible: false,
      dialogStatus: '',
      statusType: statusMap,
      statusArr: statusArr,
      empTypes: typeOptions,
      textMap: {
        update: '编辑',
        create: '添加'
      },
      rules: {
        empName: [
          { required: true, message: '必须填写', trigger: 'blur' },
          {
            max: 20,
            message: '长度最多20 个字符',
            trigger: 'blur'
          }
        ],
        phoneNum: [
          { required: true, message: '必须填写', trigger: 'blur' },
          {
            minlength: 8,
            maxlength: 20,
            message: '长度为8到20 个字符，且为数字',
            trigger: 'blur',
            validator: checkPhone
          }
        ],
        loginPwd: [
          { required: true, message: '必须填写', trigger: 'blur' },
          {
            max: 20,
            message: '长度在最多20 个字符',
            trigger: 'blur'
          }
        ],
        cardNo: [
          { min: 8, max: 10, message: '请填写8-10位的卡号', trigger: 'blur' }
        ],
        // phyCardNo: [{min: 8, max: 10, message: '请填写8-10位的物理卡号', trigger: 'blur'}],
        stationId: [{ required: true, message: '必须选择', trigger: 'change' }],
        status: [{ required: true, message: '必须选择', trigger: 'change' }]
      },
      listQuery: {
        pi: 1,
        ps: 20,
        status: '-2',
        stationId:
          getEmpInfo().isAllStation === 0 ? getEmpInfo().stationId : '',
        empType: '',
        empName: ''
      },
      isAllStation: getEmpInfo().isAllStation,
      permissionList: [],
      permissionIds: [],
      checkAll: false,
      isIndeterminate: true,
      permissions: [],
      permissionGroupList: [], // 所有分组数据
      permissionIdEnNames: [], // 所有权限ID+enName
      permissionNames: [], // 所有权限名称
      permissionsAll: [] // 已选权限
    }
  },
  watch: {
    permissions (val) {
      console.log(val)
    },
    deep: true
  },
  created () {
    // listSystemPermission({}).then(response => {
    //   const row = response.data
    //   if (row.data) {
    //     const obj = row.data
    //     for (const key in obj) {
    //       this.permissionList.push({
    //         id: obj[key].id,
    //         name: obj[key].name,
    //         enName: obj[key].enName
    //       })
    //       this.permissionIds.push(obj[key].name)
    //     }
    //   }
    // })
    listGroupPermission({}).then(response => {
      const row = response.data
      if (row.data) {
        const obj = row.data
        console.log(obj)
        for (const key in obj) {
          obj[key].checkStatus = false
          if (obj[key].permissions) {
            for (const i in obj[key].permissions) {
              this.permissionNames.push(obj[key].permissions[i].name)
              this.permissionIdEnNames.push({
                id: obj[key].permissions[i].id,
                name: obj[key].permissions[i].name,
                enName: obj[key].permissions[i].enName
              })
            }
          }
        }
        this.permissionGroupList = obj
      }
    })
    stationList({ ps: 100 }).then(response => {
      const row = response.data
      if (row.data.items) {
        const obj = row.data.items
        for (const key in obj) {
          this.stationLists.push({
            stationId: obj[key].stationId,
            stationName: obj[key].stationName
          })
        }
      }
    })
    this.getList()
  },
  methods: {
    handleCheck (val, event) {
      if (event.target.name === 'isAdmin') {
        // this.temp.isAdmin = val
        this.checkedAdmin = val
      } else if (event.target.name === 'isAllStation') {
        // this.temp.isAllStation = val
        this.checkedAllStation = val
      }
    },
    radioBind () {
      if (this.allStationCheck === '0') {
        this.checkedAdmin = 1
        this.checkedAllStation = 0
      } else {
        this.checkedAdmin = 0
        this.checkedAllStation = 1
      }
    },
    // 全选、全不选
    handleCheckAllChange (val, event) {
      console.log(val)
      console.log(this.permissionIds)
      this.permissions = val ? this.permissionIds : []
      this.isIndeterminate = false
    },
    // 单个选
    handleCheckedCitiesChange (value) {
      console.log(value)
      const checkedCount = value.length
      this.checkAll = checkedCount === this.permissionIds.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.permissionIds.length
    },

    // 全选某组、不全选某组
    handleCheckAllGroupChange (data) {
      console.log(data.checkStatus)
      if (data.checkStatus) {
        console.log(data)
        const newNameArray = []
        for (const key in data.permissions) {
          newNameArray.push(data.permissions[key].name)
          if (this.permissionsAll.length !== 0) {
            this.permissionsAll.push(...newNameArray)
            const mergeArray = Array.from(new Set(this.permissionsAll))
            this.permissionsAll = mergeArray
          } else {
            this.permissionsAll = newNameArray
          }
        }
      } else {
        for (const key in data.permissions) {
          const newName = data.permissions[key].name
          for (const i in this.permissionsAll) {
            if (newName === this.permissionsAll[i]) {
              this.permissionsAll.splice(i, 1)
            }
          }
        }
      }
      console.log(this.permissionsAll)
      this.isIndeterminate = false
    },
    // 单个选
    handleCheckedItemChange (data) {
      const newNameArray = []
      for (const key in data.permissions) {
        newNameArray.push(data.permissions[key].name)
      }
      if (isContained(this.permissionsAll, newNameArray)) {
        data.checkStatus = true
      } else {
        data.checkStatus = false
      }
      function isContained (aa, bb) {
        if (
          !(aa instanceof Array) ||
          !(bb instanceof Array) ||
          aa.length < bb.length
        ) {
          return false
        }
        const aaStr = aa.toString()
        for (var i = 0; i < bb.length; i++) {
          if (aaStr.indexOf(bb[i]) < 0) return false
        }
        return true
      }
      console.log(this.permissionsAll)
    },

    getList () {
      this.listLoading = true
      const param = Object.assign({}, this.listQuery)
      empList(param).then(response => {
        const row = response.data
        if (row.data) {
          this.list = row.data.items
          this.total = row.data.totalItems
        }
        this.listLoading = false
      })
    },
    handleModifyStatus (row, status) {
      const tempData = Object.assign({}, row)
      tempData.status = status
      empUpdate(tempData).then(res => {
        for (const v of this.list) {
          if (v.empId === row.empId) {
            const index = this.list.indexOf(v)
            this.list.splice(index, 1, tempData)
            break;
          }
        }
      })
      this.$message({
        message: '操作成功',
        type: 'success'
      })
    },
    resetTemp () {
      this.temp = {
        empId: 0,
        empName: '',
        title: ' ',
        phoneNum: '',
        loginPwd: '',
        isAdmin: 1,
        isAllStation: 0,
        stationId: '',
        stationName: '',
        permissions: [],
        permissionJson: [],
        isAllPer: '',
        status: ''
      }
    },
    handleCreate () {
      this.$prompt('请输入您的登录密码：', '提示', {
        inputType: 'password',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.{6}?/,
        inputErrorMessage: '密码格式不对',
        inputPlaceholder: '请输入密码',
        closeOnClickModal: false
      }).then(({ value }) => {
        checkEmpPwd({ pwd: value }).then(response => {
          if (response.data.code === 0) {
            this.resetTemp()
            this.clearEmpOptions()
            this.isIndeterminate = false
            this.dialogStatus = 'create';
            this.dialogFormVisible = true
            this.$nextTick(() => {
              this.$refs['dataForm'].clearValidate()
            })
          }
        })
      })
    },
    clearEmpOptions () {
      this.checkedAdmin = false
      this.checkedAllStation = false
      this.permissions = []
    },
    createData () {
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          if (this.temp.stationId) {
            const obj = this.stationLists.find(
              o => o.stationId === this.temp.stationId
            )
            this.temp.stationName = obj.stationName
          }

          // if (this.permissions.length > 0) {
          //   this.permissions.forEach(item => {
          //     const obj = this.permissionList.find(o => o.name === item)
          //     this.temp.permissionJson.push({
          //       permissionName: obj.name,
          //       permissionEnName: obj.enName
          //     })
          //   })
          //   this.temp.permissionJson = JSON.stringify(this.temp.permissionJson)
          // }

          if (this.permissionsAll.length > 0) {
            console.log(this.permissionIdEnNames)
            this.permissionsAll.forEach(item => {
              const obj = this.permissionIdEnNames.find(o => o.name === item)
              this.temp.permissionJson.push({
                permissionName: obj.name,
                permissionEnName: obj.enName
              })
            })
            this.temp.permissionJson = JSON.stringify(this.temp.permissionJson)
          }
          console.log(this.temp)
          this.temp.isAdmin = this.checkedAdmin ? 1 : 0
          this.temp.isAllStation = this.checkedAllStation ? 1 : 0
          // if (this.temp.isAdmin === 0) this.temp.isAdmin = 0
          // if (this.temp.isAllStation === 0) this.temp.isAllStation = 0
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          empAdd(this.temp)
            .then(res => {
              loading.close()
              console.log(res)
              this.dialogFormVisible = false
              this.$notify({
                title: '成功',
                message: '创建成功',
                type: 'success',
                duration: 2000
              })
              this.getList()
            })
            .catch(() => {
              loading.close()
            })
        }
      })
    },
    handleFilter () {
      this.listQuery.pi = 1
      this.getList()
    },
    handleSizeChange (val) {
      this.listQuery.ps = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.listQuery.pi = val
      this.getList()
    },
    handleUpdate (row) {
      this.$prompt('请输入您的登录密码：', '提示', {
        inputType: 'password',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.{6}?/,
        inputErrorMessage: '密码格式不对',
        inputPlaceholder: '请输入密码',
        closeOnClickModal: false
      }).then(({ value }) => {
        checkEmpPwd({ pwd: value }).then(response => {
          if (response.data.code === 0) {
            this.temp = Object.assign({}, row) // copy obj
            this.allStationCheck = row.isAllStation === 1 ? '1' : '0';
            getEmpPermission({ empId: this.temp.empId }).then(response => {
              const row = response.data
              this.permissionsAll = []
              if (row.data) {
                const obj = row.data
                for (const key in obj) {
                  this.permissionsAll.push(obj[key].name)
                }
              }
              if (!this.permissionsAll.length) {
                this.permissionsAll = []
              }
              if (!this.temp.companyId) {
                this.temp.companyId = -1
              }

              // 分组对比选择状态
              const map = {}
              const dest = []
              for (var i = 0; i < row.data.length; i++) {
                var ai = row.data[i]
                if (!map[ai.groupId]) {
                  dest.push({
                    groupId: ai.groupId,
                    name: ai.name,
                    permissions: [ai]
                  })
                  map[ai.groupId] = ai
                } else {
                  for (var j = 0; j < dest.length; j++) {
                    var dj = dest[j]
                    if (dj.groupId === ai.groupId) {
                      dj.permissions.push(ai)
                      break;
                    }
                  }
                }
              }
              console.log(dest)
              console.log(this.permissionGroupList)
              for (var t = 0; t < this.permissionGroupList.length; t++) {
                const groupId = this.permissionGroupList[t].groupId
                this.permissionGroupList[t].checkStatus = false
                if (dest) {
                  for (var h = 0; h < dest.length; h++) {
                    const newGroupId = dest[h].groupId
                    if (
                      groupId === newGroupId &&
                      dest[h].permissions.length ===
                        this.permissionGroupList[t].permissions.length
                    ) {
                      this.permissionGroupList[t].checkStatus = true
                    }
                  }
                }
              }
              this.temp.isAllPer =
                this.permissionsAll.length === this.permissionList.length
              // this.temp.isAllPer = this.stationLists.length ===
              this.isIndeterminate =
                this.permissionsAll.length > 0 &&
                this.permissionsAll.length < this.permissionList.length
              // 因为ajax是异步的原因，必须在获取数据后
              this.dialogStatus = 'update';
              this.dialogFormVisible = true
              this.$nextTick(() => {
                this.$refs['dataForm'].clearValidate()
              })
            })
          }
        })
      })
    },
    updateData () {
      console.log(this.permissions)
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          const tempData = Object.assign({}, this.temp)
          tempData['isAdmin'] = this.allStationCheck === '0' ? 1 : 0
          tempData['isAllStation'] = this.allStationCheck === '1' ? 1 : 0
          if (this.temp.status === 2) {
            tempData['status'] = -1
          }
          // if (this.permissions.length > 0) {
          //   const permissionLen = this.permissions.length
          //   const tempPermissions = []
          //   for (let i = 0; i < permissionLen; i++) {
          //     const obj = this.permissionList.find(
          //       o => o.name === this.permissions[i]
          //     )
          //     tempPermissions.push({
          //       permissionName: obj.name,
          //       permissionEnName: obj.enName
          //     })
          //   }
          //   if (this.permissions.length && this.permissions.length > 0) {
          //     tempData['permissionJson'] = JSON.stringify(tempPermissions)
          //   }
          // }
          if (this.permissionsAll.length > 0) {
            const permissionLen = this.permissionsAll.length
            const tempPermissions = []
            for (let i = 0; i < permissionLen; i++) {
              const obj = this.permissionIdEnNames.find(
                o => o.name === this.permissionsAll[i]
              )
              tempPermissions.push({
                permissionName: obj.name,
                permissionEnName: obj.enName
              })
            }
            if (this.permissionsAll.length && this.permissionsAll.length > 0) {
              tempData['permissionJson'] = JSON.stringify(tempPermissions)
            }
          }
          console.log(tempData)
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          empUpdate(tempData).then(res => {
            console.log(res)
            loading.close()
            this.getList()
            this.dialogFormVisible = false
            if (res.data.code === 0) {
              this.$notify({
                title: '成功',
                message: '更新成功',
                type: 'success',
                duration: 2000
              })
            }
          })
        }
      })
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.el-checkbox + .el-checkbox {
  margin-left: 0px;
}

.el-checkbox {
  margin-right: 10px;
}
</style>
